var pr360Viewer  = ( function ( $, pr360Viewer ) {
    'use strict';

    var panoramaContainer = undefined;
    var root = undefined;

    var closePanoramaContainer = undefined;
    var savePanoramaContainer = undefined;
    var loadingPanoramaContainer = undefined;

    var panorama = null;
    var viewer = null;
    var attachedElement = null;

    var onSave = null;

    pr360Viewer.initElements = function(options) {
        panoramaContainer = $('#panorama-container');
        root = panoramaContainer.closest('.pr360viewer');

        if (pr360Viewer.hasRoot()) {
            closePanoramaContainer = root.find('.js-panorama-close');
            savePanoramaContainer = root.find('.js-panorama-save');
            loadingPanoramaContainer = root.find('.js-panorama-loading');
        }

        if (pr360Viewer.hasCloseButton()) {
            closePanoramaContainer.on('click', function (ev) {
                pr360Viewer.close();
            });
        }

        if (pr360Viewer.hasSaveButton()) {
            options.renderer = new THREE.WebGLRenderer({
                alpha: true,
                antialias: false,
                preserveDrawingBuffer: true
            });

            savePanoramaContainer.on('click', pr360Viewer.onSaveButtonClick);
        }

        var movement = {
            enableZoom: true,
            maxZoomOut: 70, //120 je max hodnota, pri ktere fotka vypada jako fisheye
            maxZoomIn: 30,
            //Jak moc se muzeme divat do stran
            //pokud false tak se nepouzije, jinak [min, max] kde: -PI <= min < max <= PI
            verticalAngle: false
        };

        if (options.movement !== undefined) {
            movement = $.extend(options.movement, movement);
            delete options.movement;
        }

        options.horizontalView = false; //true - zakaze pohyb nahoru a dolu

        return {options: options, movement: movement};
    };

    pr360Viewer.createViewer = function(elementId, options) {
        if (options === undefined) {
            options = {};
        }

        var settings = pr360Viewer.initElements(options);

        options = $.extend({container: document.getElementById(elementId)}, settings.options);

        viewer = new PANOLENS.Viewer(options);
        viewer.OrbitControls.noZoom = !settings.movement.enableZoom;
        viewer.OrbitControls.maxFov = settings.movement.maxZoomOut;
        viewer.OrbitControls.minFov = settings.movement.maxZoomIn;

        if (settings.movement.verticalAngle !== false) {
            pr360Viewer.setVerticalAngleRestrictions(settings.movement.verticalAngle[0], settings.movement.verticalAngle[1]);
        }
    };

    pr360Viewer.setVerticalAngleRestrictions = function (min, max) {
        if (min > max) {
            console.error('min angle > max angle');
            return;
        }

        if (min < -Math.PI || max > Math.PI) {
            console.error('min,  max angle out of range -PI <= min < max <= PI');
            return;
        }

        viewer.OrbitControls.minAzimuthAngle = min;
        viewer.OrbitControls.maxAzimuthAngle = max;
    };

    pr360Viewer.setAttachedElement = function ($el) {
        attachedElement = $el;
    };

    pr360Viewer.getInitialViewByElement = function ($el) {
        if ($el === undefined) {
            throw 'Element is not defined';
        }

        var x = $el.data('panoview-x');
        var y = $el.data('panoview-y');
        var z = $el.data('panoview-z');

        if (x !== undefined && y !== undefined && z !== undefined) {
            return {x: x,y: y,z: z};
        }
        return null;
    };

    pr360Viewer.getVerticalAngleByElement = function ($el) {
        if ($el === undefined) {
            throw 'Element is not defined';
        }

        var min = $el.data('panoview-vertical-min');
        var max = $el.data('panoview-vertical-max');

        if (min !== undefined && max !== undefined) {
            return {min: min, max: max};
        }
        return null;
    };

    pr360Viewer.addPanorama = function($el) {
        try {
            pr360Viewer.addPanoramaByElement($el);
        } catch (e) {
            console.error(e);
        }
    };

    pr360Viewer.addPanoramaByImageSource = function(source, data) {
        try {
            var $img = $('<img>');
            $img.attr('src', source);

            if (pr360Viewer.hasSaveButton()) {
                $img.data('panofilepath', source);
            }

            if (data !== undefined) {
                if (data.view !== undefined) {
                    $img.data('panoview-x', data.view.x);
                    $img.data('panoview-y', data.view.y);
                    $img.data('panoview-z', data.view.z);
                }

                if (data.verticalAngle !== undefined) {
                    $img.data('panoview-vertical-min', data.verticalAngle.min);
                    $img.data('panoview-vertical-max', data.verticalAngle.max);
                }
            }

            pr360Viewer.addPanoramaByElement($img, true);
        } catch (e) {
            console.error(e);
        }
    };

    pr360Viewer.addPanoramaByElement = function ($el, fromSource) {
        fromSource = fromSource === undefined ? false : fromSource;

        if (viewer === null) {
            throw 'Create viewer first by calling createViewer.';
        }

        if ($el === undefined) {
            throw 'Element is not defined';
        }

        pr360Viewer.setAttachedElement($el);

        if (fromSource) {
            panorama = pr360Viewer.createPanorama($el[0]);
        } else {
            panorama = pr360Viewer.createPanorama($el.data('panofilepath'));
        }

        viewer.add(panorama);
        panoramaContainer.addClass('open');

        var initialView = pr360Viewer.getInitialViewByElement($el);
        if (initialView !== null) {
            viewer.getCamera().position.set(initialView.x, initialView.y, initialView.z);
        } else {
            viewer.getCamera().position.set(200, 0, 1);
        }

        var verticalAngle = pr360Viewer.getVerticalAngleByElement($el);
        if (verticalAngle !== null) {
            pr360Viewer.setVerticalAngleRestrictions(verticalAngle.min, verticalAngle.max);
        }

        viewer.getControl().update();
    };

    pr360Viewer.createPanorama = function (path) {
        if (path === undefined || path === '') {
            throw 'Undefined or empty path to file "data-panofilepath" or it is not valid image element';
        }

        return new PANOLENS.ImagePanorama(path);
    };

    pr360Viewer.close = function() {
        if (panorama !== null) {
            panorama.dispose();
            viewer.remove(panorama);
            panorama = null;
            attachedElement = null;
        }
        panoramaContainer.removeClass('open');

        if (pr360Viewer.hasLoadingState()) {
            loadingPanoramaContainer.hide();
        }
    };

    pr360Viewer.callback = function(type, func) {
        if (type === 'save') {
            onSave = func;
        }
    };

    pr360Viewer.onSaveButtonClick = function (ev) {
        ev.preventDefault();

        var promise = false;
        if (viewer !== null && onSave !== null) {
            var canvas = viewer.getRenderer().domElement;
            var camera = viewer.getCamera();

            attachedElement.data('panoview-x', camera.position.x);
            attachedElement.data('panoview-y', camera.position.y);
            attachedElement.data('panoview-z', camera.position.z);

            if (pr360Viewer.hasLoadingState()) {
                loadingPanoramaContainer.show();
            }
            promise = onSave(canvas.toDataURL(), attachedElement, {x: camera.position.x, y: camera.position.y, z: camera.position.z});
        }

        if (promise !== undefined && promise) {
            if (promise.always !== undefined) {
                promise.always(function (data) {
                    pr360Viewer.close();
                });
            } else {
                pr360Viewer.close();
            }
        }

        return false;
    };

    pr360Viewer.hasRoot = function () {
        return root !== undefined && root.length !== 0;
    };

    pr360Viewer.hasSaveButton = function () {
        return savePanoramaContainer !== undefined && savePanoramaContainer.length > 0;
    };

    pr360Viewer.hasLoadingState = function () {
        return loadingPanoramaContainer !== undefined && loadingPanoramaContainer.length > 0;
    };

    pr360Viewer.hasCloseButton = function () {
        return closePanoramaContainer !== undefined && closePanoramaContainer.length > 0;
    }

    return pr360Viewer;
})(window.jQuery, pr360Viewer || {});